import type { DocumentRepository } from "../repositories/document-repository"

export const makeDownloadDocument = (repo: DocumentRepository) =>
  (docId: string) =>
    repo.download(docId)
